import UserModel from "../models/UserModel";

export function extractUserFullName(user: UserModel) {
  return user?.profile?.fullName || '';
}